import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import {
  GSButton,
  GSCircleImage,
  GSInfoGroup,
} from "golfstatus_react_components";
import React from "react";
import { getDate } from "../../../helpers/Dates";
import "./tournament-settings-manager-item.scss";

const TournamentSettingsManagerItem = (props) => {
  const {
    role,
    roleLabel,
    user,
    resendInvitation,
    hideInvitation,
  } = props;

  // Existing users that are invited are automatically added.
  // If a user has created their account, they will have a username
  // An existing user with additional invitations would have updated invitation fields on their org/tournament user
  const existingAccount = user?.username;

  const getActivityText = () => {
    if (!existingAccount) {
      return `Added on ${getDate(user?.invitationSentAt)}`;
    }
    if (existingAccount && !user?.lastSignInAt) {
      return `No Activity`;
    }
    if (user?.invitationAcceptedAt || (existingAccount && user?.lastSignInAt)) {
      return `Last Login on ${getDate(user?.lastSignInAt)}`;
    }
  };

  const imageSection = {
    sectionItems: [
      {
        type: "primary no-wrap",
        value: <GSCircleImage size="large" url={user?.avatar} />,
      },
    ],
  };

  const infoSection = {
    sectionItems: [],
  };

  if (user?.name) {
    infoSection.sectionItems.push({
      type: "primary",
      value: user?.name,
    });
    infoSection.sectionItems.push({
      type: "secondary",
      value: user?.email,
    });
  } else {
    infoSection.sectionItems.push({
      type: "primary",
      value: user?.email,
    })
  }

  const typeSection = {
    sectionItems: [
      {
        type: "secondary",
        value: roleLabel ?? "Tournament Manager",
      },
    ],
  };

  const invitationSection = {
    style: { alignItems: "end" },
    sectionItems: [
      {
        type: "secondary no-wrap flex-end flex-start-mobile",
        value: getActivityText(),
      },
    ],
  };

  const sendActionSection = {
    type: "primary no-wrap resend-button",
    value: (
      <GSButton
        buttonIcon={faPaperPlane}
        title="Resend"
        type="light-grey"
        onClick={(e) => {
          resendInvitation?.(props);
          e?.stopPropagation?.();
        }}
      />
    ),
  };

  if (role === "tournament_manager" && user?.invitationAcceptedAt === null) {
    invitationSection?.sectionItems?.push?.({ ...sendActionSection });
  }

  const imageColumn = {
    sections: [
      {
        ...imageSection,
      },
    ],
  };

  const infoColumn = {
    fit: "stretch",
    sections: [
      {
        ...infoSection,
      },
      { ...typeSection },
    ],
  };

  const inviteColumn = {
    sections: [
      {
        ...invitationSection,
      },
    ],
  };

  const getGroup = () => {
    let group = [{ ...imageColumn }, { ...infoColumn }];
    if (!hideInvitation) {
      group.push(inviteColumn);
    }
    return group;
  };

  return (
    <tournament-settings-manager-item>
      <GSInfoGroup
        listType="mobile-vertical"
        dataGroups={getGroup()}
      ></GSInfoGroup>
    </tournament-settings-manager-item>
  );
};

export default TournamentSettingsManagerItem;
